import global from "@/global";
import { createResourceService } from "@/query/createResourceService";
import { Patient } from "@/resources/types";

const { dataProvider, queryClient, client } = global;

export const peopleService = createResourceService<Patient>({
  resource: "people",
  client,
  dataProvider,
  queryClient,
});